const VIEW_MODE = 'view';
const EDIT_MODE = 'edit';

export {
  VIEW_MODE,
  EDIT_MODE,
};
